import styles from './EmptyState.module.css'

export function EmptyState({ type = 'no-results', onReset, layoutClassName = undefined }) {
  const config = STATES[type] || STATES['no-results']

  const resetButton = onReset && type === 'no-results' && (
    <button
      className={styles.resetButton}
      onClick={onReset}
      type="button"
      style={{ marginTop: '8px', cursor: 'pointer' }}
    >
      Filters wissen
    </button>
  )

  return (
    <div className={`${styles.component} ${layoutClassName || ''}`}>
      <div className={styles.icon}>{config.icon}</div>
      <h2 className={styles.title}>{config.title}</h2>
      <p className={styles.description}>{config.description}</p>
      {resetButton}
    </div>
  )
}

const STATES = {
  'no-results': {
    icon: '🔍',
    title: 'Geen aanbiedingen gevonden',
    description: 'Probeer andere filters of zoektermen om bio aanbiedingen te vinden.',
  },
  loading: {
    icon: '🌱',
    title: 'Aanbiedingen laden...',
    description: 'We zoeken de beste biologische deals voor je op.',
  },
  error: {
    icon: '😔',
    title: 'Er ging iets mis',
    description: 'We konden de aanbiedingen niet ophalen. Probeer het later opnieuw.',
  },
  'no-comparison': {
    icon: '📊',
    title: 'Geen vergelijkingen beschikbaar',
    description: 'Er zijn geen producten gevonden die bij meerdere supermarkten in de aanbieding zijn.',
  },
  'no-upcoming': {
    icon: '🔮',
    title: 'Nog geen aanbiedingen voor volgende week',
    description: 'De aanbiedingen voor volgende week zijn nog niet beschikbaar. Kijk zaterdag of zondag terug!',
  },
}
